




















import { Component, Mixins } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import axios from 'axios'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL

@Component
export default class ActivateFlow extends Mixins(VhFixMixin) {
    activating: boolean = true
    activated: boolean = false
    error: boolean = false

    async mounted() {
        await this.activate()
    }

    async activate(): Promise<void> {
        this.activating = true

        try {
            await axios.put(`${baseUrl}${basePath}/companies/${this.$route.query.company}/activate_flow`, {
                id: this.$route.query.company,
                widgetFlowType: this.$route.query.widgetFlowType,
            })
            this.activated = true
        } catch (err) {
            this.error = true
        } finally {
            this.activating = false
        }
    }
}
